/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RelatedDeviceDto
 */
export interface RelatedDeviceDto {
    /**
     *
     * @type {string}
     * @memberof RelatedDeviceDto
     */
    deviceIdentity?: string;
    /**
     *
     * @type {string}
     * @memberof RelatedDeviceDto
     */
    deviceType?: RelatedDeviceDtoDeviceTypeEnum;
    /**
     *
     * @type {number}
     * @memberof RelatedDeviceDto
     */
    deviceArchiveId?: number;
    /**
     * Date when the device was decommissioned. Null if the device is not decommissioned.
     * @type {Date}
     * @memberof RelatedDeviceDto
     */
    decommissionedAt?: Date;
    /**
     * If present, this is a *virtual charger*, passed through to this third party central system. The real device is the parent.
     * @type {number}
     * @memberof RelatedDeviceDto
     */
    passthroughConfigId?: number;
    /**
     *
     * @type {string}
     * @memberof RelatedDeviceDto
     */
    deviceRegistrationStatus?: RelatedDeviceDtoDeviceRegistrationStatusEnum;
    /**
     *
     * @type {string}
     * @memberof RelatedDeviceDto
     */
    serviceDeviceState?: RelatedDeviceDtoServiceDeviceStateEnum;
    /**
     *
     * @type {boolean}
     * @memberof RelatedDeviceDto
     */
    online?: boolean;
    /**
     *
     * @type {string}
     * @memberof RelatedDeviceDto
     */
    serialNumber?: string;
    /**
     *
     * @type {string}
     * @memberof RelatedDeviceDto
     */
    status?: string;
}

/**
 * @export
 */
export const RelatedDeviceDtoDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type RelatedDeviceDtoDeviceTypeEnum =
    (typeof RelatedDeviceDtoDeviceTypeEnum)[keyof typeof RelatedDeviceDtoDeviceTypeEnum];

/**
 * @export
 */
export const RelatedDeviceDtoDeviceRegistrationStatusEnum = {
    Unverified: "Unverified",
    Inactive: "Inactive",
    Active: "Active",
} as const;
export type RelatedDeviceDtoDeviceRegistrationStatusEnum =
    (typeof RelatedDeviceDtoDeviceRegistrationStatusEnum)[keyof typeof RelatedDeviceDtoDeviceRegistrationStatusEnum];

/**
 * @export
 */
export const RelatedDeviceDtoServiceDeviceStateEnum = {
    NewDevice: "NewDevice",
    SetNewAuthKey: "SetNewAuthKey",
    ResetDevice: "ResetDevice",
    GetConfiguration: "GetConfiguration",
    WaitForActivate: "WaitForActivate",
    NewFirmware: "NewFirmware",
    Registered: "Registered",
} as const;
export type RelatedDeviceDtoServiceDeviceStateEnum =
    (typeof RelatedDeviceDtoServiceDeviceStateEnum)[keyof typeof RelatedDeviceDtoServiceDeviceStateEnum];

/**
 * Check if a given object implements the RelatedDeviceDto interface.
 */
export function instanceOfRelatedDeviceDto(
    value: object,
): value is RelatedDeviceDto {
    return true;
}

export function RelatedDeviceDtoFromJSON(json: any): RelatedDeviceDto {
    return RelatedDeviceDtoFromJSONTyped(json, false);
}

export function RelatedDeviceDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): RelatedDeviceDto {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        deviceArchiveId:
            json["deviceArchiveId"] == null
                ? undefined
                : json["deviceArchiveId"],
        decommissionedAt:
            json["decommissionedAt"] == null
                ? undefined
                : new Date(json["decommissionedAt"]),
        passthroughConfigId:
            json["passthroughConfigId"] == null
                ? undefined
                : json["passthroughConfigId"],
        deviceRegistrationStatus:
            json["deviceRegistrationStatus"] == null
                ? undefined
                : json["deviceRegistrationStatus"],
        serviceDeviceState:
            json["serviceDeviceState"] == null
                ? undefined
                : json["serviceDeviceState"],
        online: json["online"] == null ? undefined : json["online"],
        serialNumber:
            json["serialNumber"] == null ? undefined : json["serialNumber"],
        status: json["status"] == null ? undefined : json["status"],
    };
}

export function RelatedDeviceDtoToJSON(value?: RelatedDeviceDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        deviceType: value["deviceType"],
        deviceArchiveId: value["deviceArchiveId"],
        decommissionedAt:
            value["decommissionedAt"] == null
                ? undefined
                : value["decommissionedAt"].toISOString(),
        passthroughConfigId: value["passthroughConfigId"],
        deviceRegistrationStatus: value["deviceRegistrationStatus"],
        serviceDeviceState: value["serviceDeviceState"],
        online: value["online"],
        serialNumber: value["serialNumber"],
        status: value["status"],
    };
}
